import { UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import { ThreeDots } from 'react-bootstrap-icons';

export const ProductList = ({ products, totalPages, navigate, pageIndex, setPageIndex }) => {


    return (
        <div>
            <div className="table-responsive">
                <table className="w-100 table table-hover">
                    <thead>
                        <tr>
                            <th>Категория</th>
                            <th>Агент</th>
                            <th>Наименование</th>
                            <th>Артикул</th>
                            <th>Цена (руб.)</th>
                            <th>Картинка</th>
                            <th>Статус</th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody>
                        {products && products.length > 0 ?
                            products.map(product =>
                                <tr key={product.id}>
                                    <td>
                                        {product.category.name}
                                    </td>
                                    <td>
                                        {product.agent ? product.agent.name : `Нет агента`}
                                    </td>
                                    <td>
                                        {product.name}
                                    </td>
                                    <td>
                                        {product.sku}
                                    </td>
                                    <td>
                                        {product.price}
                                    </td>
                                    <td>
                                        <div style={{maxWidth: '75px'}}>
                                            <img src={product.imageType ? `/api/products/photo/${product.id}` : `/Content/img/NoPhoto.png`} className="img-fluid" alt="Product photo" />
                                        </div>
                                    </td>
                                    <td>
                                        {product.inActive ?
                                            <span>Неактивен</span> : <span>Активен</span>
                                        }
                                    </td>
                                    <td xs='auto' style={{
                                        verticalAlign: "middle",
                                        textAlign: "center"
                                    }}>
                                        <UncontrolledDropdown>
                                            <DropdownToggle color="light" >
                                                <ThreeDots className='' size='14' />
                                            </DropdownToggle>
                                            <DropdownMenu container="body">
                                                <DropdownItem onClick={() => navigate('details/' + product.id)}>Подробнее</DropdownItem>
                                                <DropdownItem onClick={() => navigate('edit/' + product.id)}>Изменить</DropdownItem>
                                            </DropdownMenu>
                                        </UncontrolledDropdown>
                                    </td>
                                </tr>
                            )
                            : <tr><td colSpan={8} className={"text-center"}>Список пуст</td></tr>
                        }
                    </tbody>
                </table>
            </div>
            <div className="d-flex flex-row justify-content-center align-content-center mt-3 mb-3">
                <div className="btn-group">
                    <button
                        className={pageIndex == 1 ? `btn btn-primary disabled` : `btn btn-primary`}
                        onClick={() => {
                            if (pageIndex > 1) {
                                setPageIndex(pageIndex - 1)
                            }
                        }}>Назад</button>
                    <button
                        className={(pageIndex == totalPages || totalPages == 0) ? `btn btn-primary disabled` : `btn btn-primary`}
                        onClick={
                            () => {
                                if (pageIndex <= totalPages) {
                                    setPageIndex(pageIndex + 1)
                                }
                            }}
                    >Вперед</button>
                </div>
            </div>
        </div>
    )
}